<template>
  <tr>
    <td>
      <div class="form-field">
        <div class="file-upload-field">
          <file-upload v-model="modelValue.imagen" :id="id" :defaultImage="defaultImage"></file-upload>
        </div>
      </div>
    </td>
    <td>
      <button type="button" @click="eliminar" class="btn-danger">
        <i class="fa fa-trash"></i>
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  data: function() {
    return {
      modelValue: this.value
    };
  },
  props: {
    index: {
      type: Number,
      required: true
    },
    defaultImage: {
      type: String,
      required: false,
      default: ""
    },
    value: {
      type: Object,
      required: false,
      default: function() {
        return {
          imagen: ""
        };
      }
    },
    id: {
      type: String,
      required: true
    }
  },
  methods: {
    eliminar: function() {
      this.$emit("eliminar", this.index);
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/element/TrFoto.vue